import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Pagination from "@mui/material/Pagination";
import ServiceRecordGrid from "./ServiceRecordGrid";
import ServiceRecordsModal from "./ServiceRecordsModal";
import CreateServiceRecord from "./CreateServiceRecord";
import AuthService from "../../session/AuthService";
import BuildingsApi from "../../api/BuildingsApi";
import EquipmentApi from "../../api/EquipmentApi";
// import DatePicker from "react-multi-date-picker";
import { Toaster, toast } from "react-hot-toast";
import { FiXCircle } from "react-icons/fi";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { Button, Modal } from "react-bootstrap";
import ManageUserService from "../../api/ManageUserService";

class ServiceRecordType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal2: false,
      openModal: false,
      commonArrays: [],
      changeStateforEdit: false,
      serviceResourceRecord: [],
      totalCount: 0,
      totalPageno: 0,
      currentPage: 1,
      pageNo: 0,
      search: "",
      editValue: {},
      resourcefullData: [],
      showOption: true,
      existingemployee: {},
      openplusIcon: false,
      machineName: "",
      sortBy: "",
      filterby: "",
      selectedDate: "",
      showfinalValue : null,
      fulldata : {},
      userList :[],
      plusNew : false,
      resourseValue : 0 ,
      nonplus : true 
    };
  }

  componentDidMount = () => {
   
    this.togetDropDownData();
    this.getGridData();
    this.togetEmployeeData();
    toast.dismiss();
  };



  togetEmployeeData = () => {
    let obj = { group_id: parseInt(AuthService.getUserId()) };

    ManageUserService.getAllEmployeeWithoutUserType(obj).then((response) => {
      console.log("response in userData", response);
      if (response.data && response.data.data) {
        this.setState({
          userList: response.data.data,
        },() => {
          console.log("userlist" + this.state.userList)
        });
      }else {

      }
    });
  };

  togetDropDownData = () => {
    if (this.props.Type === "1") {
      this.togetBuildingdata();
    } else if (this.props.Type === "2") {
      this.togetEquipmentdata();
    } else if (this.props.Type === "3") {
      this.togetvechileData();
    } else {
    }
  };

  getGridData = () => {
    
    
    
    let obj = {
      pageNo: 0,
      search: "",
      group_id: parseInt(AuthService.getUserId()),
      service_type: this.props.Type,
      sortby: "",
      filterby: "",
    };

    EquipmentApi.getdataByResource(obj).then((response) => {
      if (response.data && response.data.message === "success") {
        this.setState({
          serviceResourceRecord: response.data.data.servicerecord,
          totalCount: response.data.data.totalCount,
          totalPageno: response.data.data.totalPageno,
        });
      }
    });
  };





  render() {
    return (
      <>
        <div className="container-of-create-serviceRecord" id="allign-inside-the-tab-2">
          <div className="resource-conatiner">
            <Form.Label style={{ fontSize: "17px" }}>
              Sort By Resource{" "}
            </Form.Label>
            <select
              value={this.state.sortBy}
              onChange={(event) => this.sortByAlphabetize(event.target.value)}
              style={{
                backgroundColor: "rgba(243, 244, 241, 1)",
                color: "black",
                borderColor: "rgba(243, 244, 241, 1)",
                width: "100%",
                height: "42px",
                borderRadius: "5px",
              }}
            >
              <option value="">SortBy</option>
              <option value="ascending">Ascending</option>
              <option value="descending">Descending</option>
            </select>
          </div>

          <div className="date-conatiner">
            <Form.Label style={{ fontSize: "17px" }}>Date </Form.Label>
           <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={this.state.selectedDate}
                name="filterby"
                onChange={this.handleDateChange}
              />
            </LocalizationProvider>
          </div>
          <div className="search-contain-2">
            <Form.Label style={{ fontSize: "17px" }}>Search</Form.Label>

            <div className="search2">
              <span className="fa fa-search" onClick={this.search}></span>
              <input
                type="text"
                placeholder="Type Here..."
                name="search"
                value={this.state.search}
                onKeyPress={this.handleKeyPress}
                onChange={this.searchvalue}
              />
            </div>
          </div>
          {(this.state.sortBy !== "" || this.state.filterby !== "") && (
          <div className="clear-filter-container-2">
            {(this.state.sortBy !== "" || this.state.filterby !== "") && (
              <>
                <Form.Label style={{ fontSize: "17px" }}>
                  Clear Filter{" "}
                </Form.Label>

                <div
                  onClick={this.clearfilter}
                  style={{ paddingTop: "5px", paddingLeft: "20px" }}
                >
                  <FiXCircle style={{ fontSize: "25px" }} />
                </div>
              </>
            )}
          </div>
             )}
          <div className="end-button" >
          <div></div>
          {AuthService.getUserTypeAdmin() !== "3" && (
           <div className="button-end-service-record">
         
           <button
             className="btn btn-success"
             id="service-create-button"
             
             onClick={this.OpenCreateServiceRecord}
             
           >
             Create Service Record
           </button>
         </div>
          )}
            
          </div>
        </div>

        <div className="row">
          <ServiceRecordGrid
            togettheServiceData={(e) => this.openListofServiceRecord(e)}
            serviceResourceRecord={this.state.serviceResourceRecord}
            userList={this.state.userList}
            ActiveEdit={(a) => this.activeEdit(a)}
            onLoad={this.getGridData}
          />
        </div>

        <div className="mt-3" style={{ width: "99%", margin: "0 auto" }}>
          <div className="d-flex justify-content-center">
            <Pagination
              count={this.state.totalPageno}
              onChange={(event, value) => this.handlePageChange(value)}
              page={this.state.currentPage}
            />
          </div>
        </div>

        {this.state.openModal2 && (
          <>
            <ServiceRecordsModal
              handleClose={this.closeHandleclose2}
              show={this.state.openModal2}
              fulldata={this.state.resourcefullData}
              userList={this.props.userList}
              ActiveEdit={(a) => this.activeEdit(a)}
              openExistingForm={(e) => this.openExistingForm(e)}
              openplusIcon={this.state.openplusIcon}
              closeopenPlusIcon={this.closeplusIcon}
              machineName={this.state.machineName}
              openDeleteFunction={(e) => this.openDeleteFunction(e)}
             
            />
          </>
        )}
        {this.state.openModal && (
          <>
            <CreateServiceRecord
              handleClose={this.closeHandleclose}
              show={this.state.openModal}
              Type={this.props.Type}
              commonArrays={this.state.commonArrays}
              userList={this.state.userList}
              option={!this.state.changeStateforEdit ? "new" : "edit"}
              showoption={this.state.showOption}
              onLoad={this.clearfilter}
              editValue={this.state.editValue}
              editserviceRecord={this.handleEdit}
              handleclose2={this.closeHandleclose2}
              existingemployee={this.state.existingemployee}
              renderToast={(a) => this.renderToast(a)}
              openListofServiceRecord={(e) => this.openListofServiceRecord(e)}
              comefrom={"serviceRecord"}
              editreload={this.fetchDataWithFilter}
              plusNew={this.state.plusNew}
              service_resourceId={this.state.resourseValue}
              
          

            />
          </>
        )}
         {this.state.opendeleteproductDialogue && this.deleteproductPopUp()}
        <Toaster />
      </>
    );
  }

  clearfilter = () => {

    this.setState(
      {
        sortBy: "",
        filterby: "",
        pageNo: 0,
        search: "",
        group_id: parseInt(AuthService.getUserId()),
        service_type: this.props.Type,
        selectedDate: "",
        currentPage : 1
      },
      () => {
        console.log("this.state.filterby", this.state.filterby);
        const obj = {
          pageNo: 0,
          search: "",
          group_id: parseInt(AuthService.getUserId()),
          service_type: this.props.Type,
          sortby: "",
          filterby: "",
        };

        EquipmentApi.getdataByResource(obj).then((response) => {
          if (response.data && response.data.message === "success") {
            this.setState({
              serviceResourceRecord: response.data.data.servicerecord,
              totalCount: response.data.data.totalCount,
              totalPageno: response.data.data.totalPageno,
            });
          }
        });
      }
    );
  };

  handleDateChange = (date) => {
    // if (date) {
    //   // Check if date is not null or undefined
    //   console.log("date", date.toString());

    //   this.setState(
    //     {
    //       filterby: date.toString(),

    //     },
    //     () => {

    //      this.fetchDataWithFilter();
    //     }
    //   );
    // } else {
    // }

    // const formattedDate = date ? dayjs(date).format("YYYY-MM-DD") : "";
    const formattedDate = date ? dayjs(date).format("DD/MM/YYYY") : "";

    this.setState(
      {
        selectedDate: date,
        filterby: formattedDate,
      },
      () => {
        this.fetchDataWithFilter();
      }
    );
  };

  fetchDataWithFilter = () => {
    const { pageNo, search, sortBy, filterby } = this.state;

    const obj = {
      pageNo,
      search,
      group_id: parseInt(AuthService.getUserId()),
      service_type: this.props.Type,
      sortby: sortBy,
      filterby: filterby,
    };

    EquipmentApi.getdataByResource(obj).then((response) => {
      if (response.data && response.data.message === "success") {
        this.setState({
          serviceResourceRecord: response.data.data.servicerecord,
          totalCount: response.data.data.totalCount,
          totalPageno: response.data.data.totalPageno,
        });
      }
    });
  };

  sortByAlphabetize = (option) => {
    // Perform your sorting logic here based on the selected option
    // You can update your state or perform any other necessary actions
    this.setState({ sortBy: option }, () => {
      let obj = {
        pageNo: this.state.pageNo,
        search: this.state.search,
        group_id: parseInt(AuthService.getUserId()),
        service_type: this.props.Type,
        sortby: this.state.sortBy,
        filterby: this.state.filterby,
      };

      EquipmentApi.getdataByResource(obj).then((response) => {
        if (response.data && response.data.message === "success") {
          this.setState({
            serviceResourceRecord: response.data.data.servicerecord,
            totalCount: response.data.data.totalCount,
            totalPageno: response.data.data.totalPageno,
          });
        }
      });
    });
  };

  searchvalue = (event) => {
    this.setState(
      {
        [event.target.name]: event.target.value,
      },
      () => {
        if (event.target.value.length === 0) {
          this.search();
        }
      }
    );
  };

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this.search();
    }
  };

  search = () => {
    let obj = {
      pageNo: 0,
      search: this.state.search,
      group_id: parseInt(AuthService.getUserId()),
      service_type: this.props.Type,
      sortby: this.state.sortBy,
      filterby: this.state.filterby,
    };

    EquipmentApi.getdataByResource(obj).then((response) => {
      if (response.data && response.data.message === "success") {
        this.setState({
          serviceResourceRecord: response.data.data.servicerecord,
          totalCount: response.data.data.totalCount,
          totalPageno: response.data.data.totalPageno,
        });
      }
    });
  };

  openExistingForm = (e) => {
    this.setState({
      changeStateforEdit: false,
      openModal: true,
      showOption: false,
      existingemployee: e,
      resourseValue: e.service_resourceId,
      plusNew : true

    },() => {
      console.log("state value" , this.state)
    });
  };

  handlePageChange = (i) => {
    let page = null;
    if (i === 1) {
      page = 0;
    } else {
      page = i - 1;
    }
    this.setState({ currentPage: i, pageNo: page }, () => {
      let obj = {
        pageNo: this.state.pageNo,
        search: this.state.search,
        group_id: parseInt(AuthService.getUserId()),
        service_type: this.props.Type,
        sortby: this.state.sortBy,
        filterby: this.state.filterby,
      };

      EquipmentApi.getdataByResource(obj).then((response) => {
        if (response.data && response.data.message === "success") {
          this.setState({
            serviceResourceRecord: response.data.data.servicerecord,
            totalCount: response.data.data.totalCount,
            totalPageno: response.data.data.totalPageno,
          });
        }
      });
    });
  };

  // newvalue == 1

  togetBuildingdata = () => {
    let obj = {
      group_id: AuthService.getUserId(),
    };

    BuildingsApi.getBuildingData(obj).then((response) => {
      if (response.data && response.data.data) {
        this.setState({
          commonArrays: response.data.data.buildingData,
        });
      } else {
      }
    });
  };

  // newvaliue = 2

  togetEquipmentdata = () => {
    let obj = {
      group_id: AuthService.getUserId(),
    };

    BuildingsApi.getEquipmentData(obj).then((response) => {
      if (response.data && response.data.data) {
        this.setState({
          commonArrays: response.data.data.equipmentData,
        });
      }
    });
  };

  // newvalue === 3

  togetvechileData = () => {
    let obj = {
      group_id: AuthService.getUserId(),
    };

    BuildingsApi.getVehicleData(obj).then((response) => {
      if (response.data && response.data.data) {
        this.setState({
          commonArrays: response.data.data.vehicleData,
        });
      } else {
      }
    });
  };

  activeEdit = (a) => {
    this.setState({
      changeStateforEdit: true,
      editValue: a,
      openModal: true,
      showOption: true,
    });
  };

  OpenCreateServiceRecord = () => {
    this.setState({
      openModal: true,
      changeStateforEdit: false,
      showOption: true,
      plusNew : false 
    });
  };

  closeHandleclose = () => {
    this.setState({
      openModal: false,
    });
  };

  openListofServiceRecord = (e) => {
    console.log("open list of servicerecord", e);
    let obj = {
      service_type: e.service_type,
      service_resourceId: e.service_resourceId,
    };

    EquipmentApi.togetFullDataByServiceTypeandResourceId(obj).then(
      (response) => {
        console.log(response, "response");
        if (response.data && response.data.message === "success") {
          console.log("in her i want to show else...1")
          if(response.data.data.length > 0 ){
            console.log("in her i want to show else...2")
            this.setState(
              {
                resourcefullData: response.data.data,
                openModal2: true,
                openplusIcon: true,
                machineName: e.machineName,
              }
            );
          }else {
              console.log("in her i want to show else...3")
               this.closeHandleclose2();
                this.getGridData();

           
          }
        
        }
      }
    );
  };

  closeplusIcon = () => {
    this.setState({
      openplusIcon: false,
    });
  };

  closeHandleclose2 = () => {
    this.setState({
      openModal2: false,
    });
  };

 

  renderToast = (status) => {
    toast.success(`Service Record ${status} Successfully`);
  };

 

  openDeleteFunction =  (e) => {
    console.log(e , "delete ifd")

     this.setState({
       opendeleteproductDialogue : true,
       showfinalValue : e.servicerecord_Id,
       fulldata : e
     })
 
   }

   deletehandleClose = () => {

    this.setState({
     opendeleteproductDialogue : false,
     openModal2 :  true
      
     
    })
  }

 

   
  deleteServiceRecord = () => {
    let obj = {
      servicerecord_Id: this.state.showfinalValue
    };

    EquipmentApi.deleteServiceRecord(obj).then((response) => {
      console.log("response : ", response);
      if (response.data && response.data.message === "success") {
         this.deletehandleClose();
        this.openListofServiceRecord(response.data.data);
      }
    });
  };
  
  deleteproductPopUp = () => {
    return (
      <Modal show={true} size="md" centered onHide={this.deletehandleClose}>
        <Modal.Header closeButton className="CNSHeader">
          <h3 className="titleMd uppercase">Delete Service Record</h3>
        </Modal.Header>

        <Modal.Body className="">
          <div className="basicInfoWrapper newServiceFormWrapper">
            <Form.Group className="mb-3" controlId="formBasicName">
              <Form.Label>Are you sure to Delete this Service Record</Form.Label>
            </Form.Group>
          </div>
        </Modal.Body>
        <Modal.Footer className="CNSFooter">
          <Button variant="secondary" onClick={this.deletehandleClose}>
            Close
          </Button>
          <Button variant="success" type="button" onClick={this.deleteServiceRecord}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };


}
export default ServiceRecordType;
